import script from "./DateScreenStep.vue?vue&type=script&setup=true&lang=js"
export * from "./DateScreenStep.vue?vue&type=script&setup=true&lang=js"

import "./DateScreenStep.vue?vue&type=style&index=0&id=01a8b75c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a8b75c"]])

export default __exports__